document.addEventListener('alpine:init', function () {
    Alpine.data('accordions', function (groupTitle) {
        return {
            accordions: [],
            isOpen: function (id) {
                return this.accordions.includes(id);
            },
            toggle: function (id, title) {
                if (this.isOpen(id)) {
                    this.accordions = this.accordions.filter(function (accordion) { return accordion !== id; });
                }
                else {
                    this.accordions.push(id);
                    this.$store.app.track({
                        event: 'click_accordions',
                        type: 'click',
                        trigger: 'expand',
                        module: 'accordions',
                        data: {
                            groupTitle: groupTitle,
                            title: title,
                        },
                    });
                }
            },
        };
    });
});
